/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IRemoveResourceSettingsModalControllerScope extends IBaseModalControllerScope {
        workflowBlock: models.BaseWorkflowBlock;
        processConfigId: string;
        isReadonly: boolean;
        schemaProperties: Wars.Domain.Model.Dtos.SchemaPropertyDto[];
    }

    export class RemoveResourceSettingsModalController extends BaseModalController {
        scope: IRemoveResourceSettingsModalControllerScope;


        constructor(
            $scope: IRemoveResourceSettingsModalControllerScope,
            processConfigService: services.ProcessConfigurationService,
            workflowBlock: models.RemoveResourceWorkflowBlock,
            processConfigId: string,
            isReadonly: boolean,
            close: any)
        {
            super($scope, close);
            this.scope = $scope;
            this.scope.workflowBlock = workflowBlock;
            this.scope.isReadonly = isReadonly;
            this.scope.processConfigId = processConfigId;

            processConfigService.getScheduleResourceInstances(processConfigId).then(
                (schemaPropertyDtos: Wars.Domain.Model.Dtos.SchemaPropertyDto[]) => {
                    this.scope.schemaProperties = schemaPropertyDtos;
                });
        }
    }

}

warsApp.registerController('RemoveResourceSettingsModalController', ['$scope', 'processConfigurationService', 'workflowBlock', 'processConfigId', 'isReadonly', 'close']);